'use client';

export default function ScanLine() {
  return (
    <div
      className="
        absolute left-0 right-0 top-0
        h-[2px]

        bg-gradient-to-r from-transparent via-blue-400 to-transparent
        shadow-[0_0_12px_4px_rgba(59,130,246,0.7)]

        animate-scanLine
        z-20
      "
    />
  );
}